import { createApiClient, createApiTestkit } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
const API = '/_api/premium-package-pickers-api';
const getPersonalizedContentQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const response = await httpClient.post(`${API}/get-personalized-content`, request);
  return response.data;
};
export const PersonalizedContentQueriesConfig = createQueriesConfig({
  getPersonalizedContent: {
    queryFn: getPersonalizedContentQueryFn
  }
});
export const PersonalizedContentApiClient = createApiClient(PersonalizedContentQueriesConfig);
export const PersonalizedContentApiClientTestkit = createApiTestkit(PersonalizedContentQueriesConfig);
//# sourceMappingURL=personalized-content.api-client.js.map